import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CameraOutlined, MailOutlined } from '@ant-design/icons'
import { useCreator } from '../hooks/useCreator'
import { SOCIAL_ICON_EXT } from '../data/socialIcons'
import LogoMark from './LogoMark'
import BrandText from './BrandText'
import styles from './Footer.module.css'

export default function Footer() {
  const { t } = useTranslation('common')
  const creator = useCreator()

  const navLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/gallery', label: t('nav.gallery') },
    { path: '/about', label: t('nav.about') },
    { path: '/contact', label: t('nav.contact') },
    { path: '/docs/usage-guide', label: t('footer.usageGuide') },
  ]

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.top}>
          <div className={styles.brand}>
            <div className={styles.brandHeader}>
              <LogoMark size={24} />
              <BrandText text={t('footer.brand')} className={styles.brandName} />
            </div>
            <p className={styles.tagline}>{t('footer.tagline')}</p>
          </div>

          <div className={styles.linksSection}>
            <h4 className={styles.sectionTitle}>{t('footer.links')}</h4>
            <nav className={styles.links} aria-label={t('a11y.footerNav')}>
              {navLinks.map((link) => (
                <Link key={link.path} to={link.path} className={styles.link}>
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className={styles.socialSection}>
            <h4 className={styles.sectionTitle}>{t('contact.title')}</h4>
            <div className={styles.socialLinks}>
              {creator.social.map((s) => {
                const ext = SOCIAL_ICON_EXT[s.icon]
                return (
                  <a
                    key={s.platform}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.socialLink}
                    aria-label={s.platform}
                  >
                    {ext && (
                      <img
                        src={`/icons/${s.icon}.${ext}`}
                        alt=""
                        width={16}
                        height={16}
                        loading="lazy"
                        style={{ filter: 'invert(1)', marginRight: 6, verticalAlign: 'middle' }}
                      />
                    )}
                    {s.platform}
                  </a>
                )
              })}
            </div>
            <a href={`mailto:${creator.email}`} className={styles.emailLink}>
              <MailOutlined />
              {creator.email}
            </a>
          </div>
        </div>

        <div className={styles.divider} />

        <div className={styles.bottom}>
          <p className={styles.copyright}>
            <CameraOutlined className={styles.cameraIcon} />
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
          <div className={styles.meta}>
            <span>{t('footer.poweredBy')}</span>
            <span className={styles.dot}>·</span>
            <span>{t('creator.createdBy')} {creator.name}</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
